export enum UserSubType {
  User = 1,
  Agent = 2,
  Client = 3,
  Farmer = 4,
  SystemUser = 5,
  LandOwner = 6,
  LandAgent = 7,
  ReraAgent = 8,
  ReraFirmPartners = 9
}

export enum AccountType {
  User = 1,
  Agent = 2,
  Client = 3,
  Farmer = 4,
  SystemUser = 5,
  LandOwner = 6,
  LandAgent = 7,
  ReraAgent = 8,
  ReraFirmPartners = 9
}

export enum AmountSubTypes {
  BasicSalePrice = "Basic Sale Price",
  PowerBackup = "Power Backup",
  MaintenanceCharges = "Maintenance Charges",
  ParkingCharges = "Parking Charges",
  ClubMembershipFee = "Club Membership Fee",
  ParkPLC = "Park PLC",
  CornerPLC = "Corner PLC",
  WideRoadPLC = "Wide Road PLC",
  ReceiptRefund = "Receipt Refund"
}

export enum DocumentSubType {
  Pan = 1,
  AadhaarFront = 2,
  Photo = 3,
  Passport = 4,
  DrivingLicense = 5,
  BankAccount = 6,
  VoterIdFront = 7,
  ApplicationForm = 8,
  Resume = 9,
  BGVerificationReport = 10,
  Khatauni = 11,
  Sajra = 12,
  Mutation = 13,
  ATS = 14,
  SaleDeed = 15,
  AadhaarBack = 16,
  PaymentReceiptsAllotment = 17,
  PaymentReceiptsAgent = 18,
  VoterIdBack = 19,
  LayoutPlan = 20,
  ApprovedMap = 21,
  WelcomeLetter = 22,
  IGRS = 23,
  SenctionLetter = 24,
  NOCofConstructions = 25,
  ADAPaymentReceipts = 26,
  NajoolNOC = 27,
  CertificateOfIncorporation = 28,
  PartnershipDeed = 29,
  ProjectCompletionCertificate = 30,
  QPRAndAnnexures = 31,
  NonEncumbranceCertificate = 32,
  JointDevelopmentAgreement = 33,
  IndemnityBond = 34,
  FireFightingNOC = 35,
  DrinkingWaterfacilities = 36,
  EmergencyEvacuation = 37,
  RenewableEnergy = 38,
  ATSPerformaformatCopy = 39,
  AllotmentLetterformatCopy = 40,
  TAN = 41,
  ITR = 42,
  BalanceSheet = 43,
  AuthorizationLetter = 44,
  BookingCancellationRequest = 56
}

export const enum DocumentTypes {
  KYC = 1,
  Agreements = 2,
  Application = 3,
  Property = 4,
  PaymentReceipts = 5,
  UID = 6,
  RERA = 7,
  Letters = 8,
  Finance = 9,
  Firm = 10,
  ExplorationReport = 11,
  CancellationRequest = 12
}

export const enum SourceType {
  Direct = 2
}

export const enum ExportedfileStyles {
  primaryColor = '#BA141A',
  secondaryColor = '#ffffff',
  headerRowColor = '#f8f8f8',
  evenRowColor = '#fcfcfc',
  oddRowColor = '#fff',
  pdfInnerBorderColor = '#dde2eb',
  pdfouterborderColor = '#babfc7',
}

export const enum ToasterMessage {
  successMessage = 'added Successfully',
  updateSuccessMessage = 'updated Successfully'
}

export const enum Base64FileFormats {
  JPEG = 'data:image/jpeg;base64,',
  PDF = 'data:application/pdf;base64,',
}

export const enum BrowsedFileFormats {
  JPEG = '.jpg, .jpeg, .png',
  PDF = '.pdf'
}

export const enum AssetsData {
  UserDefaultProfilePic = 'assets/images/profile.svg'
}

export enum AddressType {
  Current = 1,
  Permanent = 2,
  Office = 3,
  Shop = 4,
  Institute = 5,
  University = 6,
  Firm = 7
}
export enum AmountSubType {
  BaseAmount = 1,
  PowerBackup = 2,
  MaintenanceCharges = 3,
  ParkingCharges = 4
}

export enum commonListButton {
  ok = 'Done',
  cancel = 'Cancel'
}

export enum BloodGroup {
  APositive = 'A+',
  ANegative = 'A-',
  BPositive = 'B+',
  BNegative = 'B-',
  ABPositive = 'AB+',
  ABNegative = 'AB-',
  OPositive = 'O+',
  ONegative = 'O-'
}

export enum SaleMapColors {
  NotFound = '#808080',
  Allotted = '#FF0000',
  NotAllotted = '#0000FF',
  Garden = '#7CFC00',
  Temple = '#FF7722',
  Water = '#c7fffd',
  Mortgage = '#ffffff'
}

export enum AcquisitionMapColors {
  NotFound = '',
  Prospect = '#FF0000',
  TokenPaid = '#0000FF',
  ATS = '#F9B4F6',
  PartiallyAcquired = '#FFFF00',
  Mutation = '#5CE65C',
  Acquired = '#6cd581ff',
  Subhash = '#FFFF00',
  interested = '#eaea1cff'
}

export enum KhasraLevelMapColors {
  MainKhasra = '#0000FF',
  AdjacentKhasra = '#e62ec4'
}

export enum TokenPropertyUrl {
  contactNumber = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone",
  userId = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier",
  userName = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
}

export enum KMLFor {
  Dashboard = 'Dashboard',
  Inventory = 'Inventory',
  Sales = 'Sales',
  Acquisition = 'Acquisition'
}

export enum KMLLevels {
  Country = 'country',
  State = 'state',
  District = 'district',
  Tehsil = 'tehsil',
  Village = 'village',
  khasra = 'khasra',
  Project = 'project',
  Live = 'live',
  Operations = 'operations'
}

export enum UnitMeasurement {
  Hectare = 1,
  Acre = 2,
  Beegha = 3,
  Biswa = 4,
  SqMeter = 5,
  SqYards = 6,
  SqFeet = 7,
  Naali = 8
}

export interface ThemeConfig {
  primaryBackgroundColor: string;
  secondaryBackgroundColor?: string;
  primaryFontColor: string;
  secondaryFontColor: string;
  logoUrl?: string;
  organizationName?: string;
}


// models/location.model.ts
export interface LocationPoint {
  name: string;
  lat: number;
  lon: number;
  distance?: number;
}


export const DISTANCE_LOCATIONS: ReadonlyArray<LocationPoint> = [
  { name: 'Airport', lat: 26.747221, lon: 82.150299 },
  { name: 'Ram Mandir', lat: 26.795645, lon: 82.195429 },
  { name: 'Hanuman Garhi', lat: 26.79583086910487, lon: 82.20192573599556 },
  { name: 'Raja Dashrath Smadhi', lat: 26.713800, lon: 82.268439 },
  { name: 'Ayodhya Railway Junction', lat: 26.788303, lon: 82.199796 },
  { name: 'Ayodhya Railway Cantt', lat: 26.76831533482747, lon: 82.13176117429795 }
];

export enum TransTransRefType {
  Sales = "Sale",
  Purchase = "Purchase",
  LoanReceived = "LoanReceived",
  LoanOut = "LoanOut",
  Gift = "Gift",
  Expense = "Expense"
}

export enum LedgerMode {
  Vault = 1,
  Combined = 2
}

export enum BrandingMessages {
  welcomeMessage = 'Welcome to BharatBhuVikas CRM - Your Gateway to Smart Land Management',
  copyrightMessage = '© 2026 BharatBhuVikas.com. All rights reserved.',
}

export class Servicesoffered {
  public static AggregatorServices: string[] = ['Land Stitching & Mapping', 'Unified Title Tracking', 'Automated Due Diligence', 'ESG & Carbon Reports', 'Investor Pitch Generator', 'Blockchain-Secured Land Data']
  public static DeveloperServices: string[] = ['Dynamic Site Feasibility', 'Unified Ownership CRM', 'Automated Constraint Blending', 'GDV & Residential Value Insight', 'Layout Visualisation', 'BIM-Site Synergy']
}

export class DocumentDump {
  public static MaxFileSizeMB: number = 50; // Maximum allowed file size in MB for uploads
  public static AllowedType: string[] = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    // Audio
    'audio/mp3',
    'audio/mpeg', // .mp3
    'audio/wav',  // .wav
    'audio/x-wav',
    'audio/ogg',
    // Video
    'video/mp4',  // .mp4
    'video/x-msvideo', // .avi
    'video/x-matroska', // .mkv
    'video/quicktime', // .mov
    // DWG (AutoCAD)
    'application/acad',
    'application/x-acad',
    'application/autocad_dwg',
    'image/vnd.dwg',
    'application/dwg',
    'application/x-dwg',
    'application/octet-stream',
    'dwg' // fallback for some DWG uploads
  ];
  public static AllowedFileInputType: string = '.pdf,image/*,audio/*,video/*,.mp4,.dwg';
}

export class RootPaths {
  public static KMLFiles = "KML Files";
}
